import * as types from './types';

const initialState = {
  modalParams: {},

  [types.MODAL_PARAM_ONBOARDING]: false,
  [types.MODAL_PARAM_EMAIL_VERIFICATION]: false,
  [types.MODAL_PARAM_PHONE_VERIFICATION]: false,
  [types.MODAL_INVITE_MEMBER]: false,
  [types.MODAL_UNSAVED_BUYBOX_CHANGES]: false,
  [types.MODAL_ACCEPT_TERMS_AND_CONDITIONS]: false,
  [types.PRE_DEALS_MODAL_TRAINING]: false,
  [types.MODAL_CONTACT_SPECIALIST]: false,
  [types.MODAL_PARAM_WHITELABEL_BUYERS_TRAINING]: false,
  [types.MODAL_EDIT_FIELD]: false,
  [types.MODAL_CREATE_ENTITY]: false,
  [types.MODAL_ADD_ASSET]: false,
  [types.MODAL_WHITELABEL_ACCEPT_TERMS_AND_CONDITIONS]: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.SET_MODAL_STATE:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}
